import { inject, Injectable } from '@angular/core';
import { HttpClient, HttpEvent } from '@angular/common/http';
import { Observable } from 'rxjs';
import { UploadRequest } from '../models/file-uploader';

@Injectable()
/**
 * Service responsible for uploading files.
 */
export class FileUploadService {
  private http = inject(HttpClient);

  /**
   * Performs a custom upload request using a predefined CustomUploadRequest.
   * @param customRequest The custom upload request containing URL and FormData.
   * @returns An Observable of HttpEvent.
   */
  public readonly upload = (
    customRequest: UploadRequest
  ): Observable<HttpEvent<unknown>> => {
    return this.http.post(customRequest.url, customRequest.formData, {
      reportProgress: true,
      observe: 'events'
    });
  }
}
